import toZipCodeDigits from '~/common/masked/toZipCodeDigits';

// A tela mostra o CEP com mascara; o backend recebe so os digitos (nao depende da ordem de
// deploy do mt-person-v2, que tambem normaliza).
export function normalizeSubmitData(data: any) {
  return data?.zipCode ? { ...data, zipCode: toZipCodeDigits(data.zipCode) } : data;
}
